import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import FilterItems from '../../FilterItems/FilterItems';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const ViewsByProfile = ({
    profilesIdsSelected
}) => {
    const [id, setId] = useState(null);
    const [dsScreen, setDsScreen] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [usernameUpdate, setUsernameUpdate] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(false);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [screensIdsSelected, setViewsIdsSelected] = useState(null);
    const [isActiveFilter, setIsActiveFilter] = useState('S');
    const [loadingViewPanel, setLoadingViewPanel] = useState(false);
    const [screenRecordsGrid, setViewsRecordsGrid] = useState(null);
    const [screenRecordsNewRecords, setScreenRecordsNewRecords] = useState(null);
    const [screenRecordsNewRecordsIdsSelected, setScreenRecordsNewRecordsIdsSelected] = useState([]);
    const [attributesDetailViewPanel, setAttributesDetailItemPanel] = useState(null);
    const readOnlyAttributes = !(inserting || updating);

    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "dsScreen", value: dsScreen, setter: setDsScreen },
        {
            name: "isActive", value: isActive, setter: setIsActive, resetValue: 'S', readOnlyGrid: true,
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "usernameUpdate", value: usernameUpdate, setter: setUsernameUpdate },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];


    const [idNewRecord, setIdNewRecord] = useState(null);
    const [dsScreenNewRecord, setDsScreenNewRecord] = useState(null);

    const attributeListNewRecord = [
        { name: "id", value: idNewRecord, setter: setIdNewRecord, allowsMultipleRecordsSelected: true },
        { name: "dsScreen", value: dsScreenNewRecord, setter: setDsScreenNewRecord },
    ];

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setViewsIdsSelected([])
    }, [isActiveFilter]);

    useEffect(() => {
        reloadListViews()
    }, [profilesIdsSelected, isActiveFilter])

    useEffect(() => {
        // A grid é recarregada após salvar (post/put); selecionar uma linha só busca o detalhe
        if ((!screensIdsSelected || screensIdsSelected.length != 1) && updating) {
            setUpdating(false)
        }

        if (!screensIdsSelected || screensIdsSelected.length > 1) {
            setViewsIdsSelected([])
        }
    }, [screensIdsSelected, updating]);


    useEffect(() => {
        if (screensIdsSelected && screensIdsSelected.length === 1) {
            fetchDataDetail(screensIdsSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [screensIdsSelected]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '83%',
    };

    useEffect(() => {
        if (profilesIdsSelected) {
            if (profilesIdsSelected.length === 1) {
                reloadListViewsNewRecord()
            } else if (profilesIdsSelected.length != 1) {
                setScreenRecordsNewRecords(null);
            }
        }
    }, [profilesIdsSelected]);

    useEffect(() => {
        if (!inserting) {
            setScreenRecordsNewRecordsIdsSelected([])
        }
    }, [inserting]);

    async function reloadListViewsNewRecord() {
        const screens = await ExecuteAxios.api('get', `/screens/get-list-screens-grid/`);
        setScreenRecordsNewRecords(screens);
    }

    async function reloadListViews() {
        const parameters = {
            profileId: (profilesIdsSelected && profilesIdsSelected[0]) ? profilesIdsSelected[0] : 0,
            isActive: isActiveFilter
        }
        const screens = await ExecuteAxios.api('get', `/profile-screens/get-profile-screens-grid/`, { params: parameters });
        setViewsRecordsGrid(screens);
        RemoveIdsNotFound.remove(screens, setViewsIdsSelected, screensIdsSelected)
    }

    const fetchDataDetail = async (screensIdsSelected) => {
        const parameters = { id: screensIdsSelected ? screensIdsSelected : 0 }
        const item = await ExecuteAxios.api('get', `/profile-screens/get-profile-screens-detail/`, { params: parameters })
        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }

        if (!screensIdsSelected || screensIdsSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getItemPanelListOrDetail = () => {
        if (!updating && !inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setViewsIdsSelected}
                    idsSelected={screensIdsSelected}
                    data={screenRecordsGrid}
                    attributeList={attributeList}
                />
            )
        } else if (updating) {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailViewPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        } else if (inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setScreenRecordsNewRecordsIdsSelected}
                    idsSelected={screenRecordsNewRecordsIdsSelected}
                    data={screenRecordsNewRecords}
                    attributeList={attributeListNewRecord}
                />)
        }
    }

    async function postItem() {
        try {
            setLoadingViewPanel(true)
            const response = await ExecuteAxios.api('post', `/profile-screens/`, {
                profileId: profilesIdsSelected[0],
                screensIds: screenRecordsNewRecordsIdsSelected
            });

            if (response) {
                await reloadListViews()
            }
            return response;
        } finally {
            setLoadingViewPanel(false)
        }
    }

    async function putItem() {
        try {
            setLoadingViewPanel(true)
            const response = await ExecuteAxios.api('put', `/profile-screens/`, {
                id: id,
                profileId: profilesIdsSelected[0],
                isActive: isActive
            });

            if (response) {
                await reloadListViews()
            }

            return response;
        } finally {
            setLoadingViewPanel(false)
        }
    }

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', height: '100%', width: '100%'
        }}
            className={'main-modal two right'}
        >
            <FilterItems
                isActiveFilter={isActiveFilter}
                onUpdatesIsActiveFilter={setIsActiveFilter}
            />
            <LoadingIndicator loaded={!loadingViewPanel}>

                <Panel
                    style={itemPanelStyle}
                    titlePage={'Visões por perfil'}
                    setUpdating={setUpdating}
                    setInserting={setInserting}
                    inserting={inserting}
                    updating={updating}
                    enableEdit={true}
                    canEdit={screensIdsSelected && screensIdsSelected.length === 1 && profilesIdsSelected && profilesIdsSelected.length === 1}
                    putFunction={putItem}
                    enableNewRecord={true}
                    canNewRecord={profilesIdsSelected && profilesIdsSelected.length === 1}
                    postFunction={postItem}
                    canViewCRUD={true}
                    readOnly={false}
                    recordsSelected={screensIdsSelected}
                    screensOnlyOneRecordCRUD={true}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={attributesDetailViewPanel}
                    attributeList={attributeList}
                    onUpdateIdSelected={setViewsIdsSelected}
                >
                    {getItemPanelListOrDetail()}
                </Panel>
            </LoadingIndicator >
        </div>
    );

}
export default ViewsByProfile;